export const Types = {
  BUSCA_CLIENTE_ACTION: "buscaCliente/BUSCA_CLIENTE_ACTION",
  BUSCA_CLIENTE_ACTION_SUCCESS: "buscaCliente/BUSCA_CLIENTE_ACTION_SUCCESS",
  SORTEIA_CLIENTE: "buscaCliente/SORTEIA_CLIENTE",
  LIMPA_ID_CAMPANHA: "buscaCliente/LIMPA_ID_CAMPANHA"
};

const INITIAL_STATE = {
  data: [],
  id_campanha: null
};

export default function buscaCliente(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.BUSCA_CLIENTE_ACTION:
      return { ...state };
    case Types.BUSCA_CLIENTE_ACTION_SUCCESS:
      return { ...state, data: action.payload.data };
    case Types.SORTEIA_CLIENTE:
      return { ...state, id_campanha: action.payload.id };
    case Types.LIMPA_ID_CAMPANHA:
      return { ...state, id_campanha: null };
    default:
      return state;
  }
}

export const Creators = {
  buscaClienteAction: search => ({
    type: Types.BUSCA_CLIENTE_ACTION,
    payload: { search }
  }),
  buscaClienteActionSuccess: data => ({
    type: Types.BUSCA_CLIENTE_ACTION_SUCCESS,
    payload: { data }
  }),
  sorteiaCliente: id => ({
    type: Types.SORTEIA_CLIENTE,
    payload: { id }
  }),
  limpaIdCampanha: () => ({
    type: Types.LIMPA_ID_CAMPANHA
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/buscaCliente.js